import {Grid} from '@material-ui/core'
import React from 'react'
import moment from 'moment'

// custom css
import TabPanel from './Tabs/TabPanel'

const TabDetails = ({data = {}, ...root}) => {
  const {
    start_date,
    end_date,
    reserve_for = {},
    items = [],
    entity_object_ids = [],
    reservation_notification = [],
    entity_key,
  } = data || {}
  return (
    <TabPanel {...root}>
      <Grid container spacing={2} className="ap-mb-28">
        <Grid item xs={6} className="ap-mb-2">
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12} className="ap-py-0">
                <span className="tab-label-value ap-m-0 ap-typography ap-typography--sm">From</span>
              </Grid>
              <Grid item xs={12} className="ap-py-0">
                <span className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                  {moment(start_date).format('MM/DD/YYYY h:mm a')}
                </span>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={6} className="ap-mb-2">
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12} className="ap-py-0">
                <span className="tab-label-value ap-m-0 ap-typography ap-typography--sm ">To</span>
              </Grid>
              <Grid item xs={12} className="ap-py-0">
                <span className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                  {moment(end_date).format('MM/DD/YYYY h:mm a')}
                </span>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12} className="ap-mb-2">
          <div>
            <Grid container spacing={2} ap-px-2>
              <Grid item xs={12} className="ap-py-0">
                <span className="tab-label-value ap-m-0 ap-typography ap-typography--sm ">For</span>
              </Grid>
              <Grid item xs={12} className="ap-py-0">
                <span className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                  {reserve_for.value}
                </span>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12} className="ap-mb-2">
          <div>
            <Grid container spacing={2} ap-px-2>
              <Grid item xs={12} className="ap-py-0">
                <span className="tab-label-value ap-m-0 ap-typography ap-typography--sm ">
                  Items
                </span>
              </Grid>
              <Grid item xs={12} className="ap-py-0">
                {items.map((item, i) => (
                  <div
                    key={i}
                    className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray"
                  >
                    <a
                      style={{color: 'inherit'}}
                      href={`${localStorage.parent_origin}/${entity_key}/${entity_object_ids[i]}`}
                      target="_top"
                    >
                      {item.primary} - {item.secondary}
                    </a>
                  </div>
                ))}
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12} className="ap-mb-2">
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12} className="ap-py-0">
                <span className="tab-label-value ap-m-0 ap-typography ap-typography--sm ">
                  Notifications
                </span>
              </Grid>
              <Grid item xs={12} className="ap-py-0">
                {(reservation_notification || []).length > 0 ? (
                  reservation_notification.map((n, i) => (
                    <span
                      key={i}
                      className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray"
                    >
                      {n.time} {n.unit} before
                    </span>
                  ))
                ) : (
                  <span className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                    none
                  </span>
                )}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </TabPanel>
  )
}

export default TabDetails
